var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.105,
    height: 105.548,
    viewBox: "0 0 90.105 105.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_documentation_3194800",
    transform: "translate(-5.4 9.5)",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(5.4 -9.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    "data-name": "Path 3147",
    d: "M98.727,21.61,80.395,3.278A2.6,2.6,0,0,0,78.506,2.5H38.065A2.7,2.7,0,0,0,35.4,5.166V15.5H25.066A2.7,2.7,0,0,0,22.4,18.166V28.5H12.066A2.7,2.7,0,0,0,9.4,31.165v74.217a2.7,2.7,0,0,0,2.666,2.666H70.84a2.7,2.7,0,0,0,2.666-2.666V95.049H83.839a2.7,2.7,0,0,0,2.666-2.666V82.05H96.838A2.7,2.7,0,0,0,99.5,79.383V23.5A2.6,2.6,0,0,0,98.727,21.61ZM78.95,9.388,92.616,23.054H78.95ZM68.173,102.6H14.844V33.831H22.4V92.382a2.7,2.7,0,0,0,2.666,2.666H68.173Zm13-12.888H27.843V20.832H35.4V79.383a2.7,2.7,0,0,0,2.666,2.666H81.173Zm-40.33-13V7.944H73.618V25.832A2.7,2.7,0,0,0,76.284,28.5H94.172V76.717Z",
    transform: "translate(-9.4 -2.5)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3148",
    "data-name": "Path 3148",
    d: "M71.112,33.1H46.391a1.991,1.991,0,1,0,0,3.982H71.112a1.991,1.991,0,1,0,0-3.982Z",
    transform: "translate(7.461 1.356)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    "data-name": "Path 3149",
    d: "M71.112,45.2H46.391a1.991,1.991,0,0,0,0,3.982H71.112a1.991,1.991,0,0,0,0-3.982Z",
    transform: "translate(7.461 2.881)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3150",
    "data-name": "Path 3150",
    d: "M71.112,57.2H46.391a1.991,1.991,0,1,0,0,3.982H71.112a1.991,1.991,0,1,0,0-3.982Z",
    transform: "translate(7.461 4.393)",
    fill: "#f37320"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.1d86fba062960c44231846ec115cea66.svg";
export { ForwardRef as ReactComponent };